module.exports = __webpack_public_path__ + "img/paypal.bdbbe7c2.png";